import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import "./admin.css";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export default function EditNameUser({ id, rafraichir, token }) {
  const [newUser, setNewUser] = useState({ nom: "", prénom: "", téléphone: "" });
  const [messageMailInvalide, setMessageMailInvalide] = useState("");
  const [messageUpdateMail, setMessageUpdateMail] = useState("");
  const navigate = useNavigate();

  const showMessagePopup = (message) => alert(message);

  const clearMessages = () => {
    setTimeout(() => {
      setMessageMailInvalide("");
      setMessageUpdateMail("");
    }, 5000);
  };

  useEffect(() => { clearMessages(); }, [messageMailInvalide, messageUpdateMail]);

  const handleChange = (event) => {
    setNewUser({ ...newUser, [event.target.name]: event.target.value });
  };

  const handlePhoneChange = (event) => {
    const cleaned = event.target.value.replace(/[^\d\s+]/g, "");
    setNewUser({ ...newUser, téléphone: cleaned });
  };

  const validatePhone = (phone) => {
    if (!phone || phone.trim() === "") return true;
    const phoneRegex = /^(\+33|0033|0)[1-9](\s?\d{2}){4}$/;
    return phoneRegex.test(phone.replace(/\s/g, ""));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validatePhone(newUser.téléphone)) {
      setMessageMailInvalide("Numéro de téléphone invalide (ex: 06 12 34 56 78 ou +33612345678)");
      return;
    }

    axios.patch(
      `${API_URL}/users/${id}`,
      { prenom: newUser.prénom, nom: newUser.nom, telephone: newUser.téléphone },
      { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token } }
    )
      .then((response) => {
        if (response.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate.push("/login");
        } else {
          return response.data.data;
        }
      })
      .then(
        () => { setMessageUpdateMail("Données mises à jour !"); rafraichir(); },
        (error) => console.log(error)
      );
  };

  useEffect(() => {
    axios.get(`${API_URL}/users?limit=1000&offset=0`, {
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token }
    })
      .then((response) => {
        const selectedUser = response.data.data.find((user) => user.id === id);
        if (selectedUser) {
          setNewUser({
            nom: selectedUser.nom || "",
            prénom: selectedUser.prenom || "",
            téléphone: selectedUser.telephone || "",
          });
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate("/login");
        }
      });
  }, [id, token, navigate]);

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <input
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={handleChange}
        value={newUser.nom}
        placeholder="Nom"
        name="nom"
        type="text"
      />
      <input
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={handleChange}
        value={newUser.prénom}
        placeholder="Prénom"
        name="prénom"
        type="text"
      />
      <input
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={handlePhoneChange}
        value={newUser.téléphone}
        placeholder="Téléphone (optionnel)"
        name="téléphone"
        type="tel"
        maxLength={16}
      />
      <input
        type="submit"
        value="Mettre à jour"
        className="w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer border-none"
      />
      {messageMailInvalide && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
          {messageMailInvalide}
        </div>
      )}
      {messageUpdateMail && (
        <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
          {messageUpdateMail}
        </div>
      )}
    </form>
  );
}